import { render, staticRenderFns } from "./EventModalCatalogAdServicesForm.vue?vue&type=template&id=59be1ada&scoped=true"
import script from "./EventModalCatalogAdServicesForm.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogAdServicesForm.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogAdServicesForm.vue?vue&type=style&index=0&id=59be1ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be1ada",
  null
  
)

export default component.exports